import Vue from 'vue'
import Vuex from 'vuex'
import '@/assets/js/api'

Vue.use(Vuex)


//* State
export const state = () => ({
  direction32to31:3.1,
  direction33to32:3.1,
  direction34to33:-0.05,

  locationRenew: {
    area:"鳳林",
    path:'/',
    number: 0,
    name: "鳳林",
    inf: "鳳林鎮坐落於中央山脈和海岸山脈之間，是一個以客家人為主的客庄小鎮。於西元2014年獲得國際慢城組織的認證，有一種樂活愜意的氛圍。每年皆會舉辦西瓜節、百鬼夜行等有趣的活動。此外，小鎮中的老樹、傳統菸樓、老屋、農家田野風光、平價實惠的小吃、麻花捲與客家美食，處處顯現了人與土地友善共存的客家精神。當你來到這裡，會不自覺放慢旅遊的腳步，遠離日常忙碌的節奏，享受獨特的慢遊體驗，深刻感受客家小鎮的慢城魅力。",
    mainimg:"location1/p1-1-1.jpg",
    imgList: {
      items: [
        {
          id:11101,
          img: "location1/p1-1-1.jpg"
        },
      ]
    },
    iframemap:"https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d116865.73803318875!2d121.37889711838136!3d23.74544250981376!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3468ae11a2a59a0b%3A0x98e338157ab0b64e!2zOTc16Iqx6JOu57ij6bOz5p6X6Y6u!5e0!3m2!1szh-TW!2stw!4v1698300368439!5m2!1szh-TW!2stw",
    

  },
});



export const mutations = {
  // 
  SET_location(state, payload) {
    state.locationRenew = payload;
  },

  SET_direction32to31(state, payload) {
    state.direction32to31 = payload;
  },

  SET_direction33to32(state, payload) {
    state.direction33to32 = payload;
  },

  SET_direction34to33(state, payload) {
    state.direction34to33 = payload;
  },

};


export default new Vuex.Store({
  state,
  mutations,
})
